import { Statement } from './statement'

/**
 * Model representing a contract article.
 */
export class Article {

  public id: string;
  public title: string;
  public help: string;
  public mandatory: boolean = false;
  public statements: Statement[];
  public dummy: boolean = false;
  public type: number = 1;
  public static: boolean = false;
  public addRows: number = 0;

  constructor(jsonStr: string) {
    try {
      let jsonObj: any = JSON.parse(jsonStr);
      for (let prop in jsonObj) {
        this[prop] = jsonObj[prop];
      }
    } catch (e) {
      console.warn(e);
    }

  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/model/article.ts